import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import SectionGroup from 'app/components/general/SectionGroup';

interface IConnectionGroupItem {
  type: 'customer' | 'team' | 'payout' | 'match-payment' | 'payment-request' | 'competition';
  title: string;
  links: {
    name: string;
    id: string;
  }[];
}

interface IConnectionGroupProps {
  title: string;
  isLoading: boolean;
  items: IConnectionGroupItem[];
}

export default class ConnectionGroup extends React.Component<IConnectionGroupProps> {
  static defaultProps: IConnectionGroupProps = {
    title: undefined,
    isLoading: false,
    items: [],
  };

  renderLink = (type, link): React.ReactNode => {
    let linkUrl = '';
    switch (type) {
      case 'customer':
        linkUrl = `/customers/detail/${link.id}`;
        break;
      case 'team':
        linkUrl = `/teams/detail/${link.id}`;
        break;
      case 'competition':
        linkUrl = `/competitions/${link.id}`;
        break;
      case 'payout':
        linkUrl = `/payouts/detail/${link.id}`;
        break;
      case 'match-payment':
        linkUrl = `/payments/segments/matches/detail/${link.id}`;
        break;
      case 'payment-request':
        linkUrl = `/payments/segments/requests/detail/${link.id}`;
        break;
      default:
        linkUrl = '';
        break;
    }
    return (<Link to={linkUrl}>{link.name}</Link>);
  }

  renderConnections = (): React.ReactNode => _.map(this.props.items, (item, index) => {
    const filteredLinkComponents = _.filter(item.links, (i) => {
      if (!_.isEmpty(i.id) && !_.isEmpty(i.name)) {
        return true;
      }
      return false;
    });
    const linkComponents = _.map(filteredLinkComponents, (link, count) => (
      <>
        {this.renderLink(item.type, link)}
        {(count + 1) !== item.links.length && (<span>, </span>)}
      </>
    ));
    if (_.isEmpty(linkComponents)) {
      return null;
    }
    return (
      <div className={classnames('row', { 'with-margin-top-10': index > 0 })}>
        <div className="col col-4 text-grey">
          {item.title}
        </div>
        <div className="col">
          {!_.isEmpty(linkComponents) && linkComponents}
          {_.isEmpty(linkComponents) && <span>-</span>}
        </div>
      </div>
    );
  })

  render(): React.ReactNode {
    return (
      <SectionGroup title={this.props.title} isLoading={this.props.isLoading}>
        {this.renderConnections()}
      </SectionGroup>
    );
  }
}
